<template>
  <div
    class="min-vh-100 h-100 w-100 d-flex flex-column align-items-center"
  >
    <div
      class="w-100"
      style="height: calc(100vh - 3.125rem) !important;"
    >
      <div class="blank-layout-style flex-fill">
        <!-- Begin Page Content -->
        <slot />
        <!-- End of Page Content -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.blank-layout-style {
  position: relative;
  height: inherit !important;
  overflow-y: auto;
}
</style>
